import type { NuxtI18nInstance } from '@nuxtjs/i18n'

/**
 * Replaces the `{LANGUAGE}` placeholder of a URL from the navigation config
 * with the current locale code, e.g. `https://help.vsmonitor.com/dd/{LANGUAGE}.html`.
 *
 * @param {NuxtI18nInstance} i18n - The i18n instance (`$i18n`).
 * @param {string} url - The URL with the placeholder.
 * @returns {string} - The URL for the current locale.
 */
export const localizeUrl = (i18n: NuxtI18nInstance, url: string): string => {
  const values = { LANGUAGE: i18n.localeProperties.code.toUpperCase() }
  // the formatter returns the parts of the string as an array
  return (i18n.formatter.interpolate(url, values, '') ?? []).join('')
}
